<template>
  <Layout title="Transport Voucher" description="Review and manage transport vouchers">
    <div class="container py-5" style="max-width: 1100px;">
      <div class="card shadow">
        <div class="card-header bg-dark text-light">
          <h4 class="mb-0">Transport Voucher</h4>
        </div>

        <div class="card-body">

          <!-- Canvas -->
          <div class="text-center mb-4">
            <canvas
              ref="voucherCanvas"
              class="border rounded bg-white w-100"
              style="max-width: 900px;"
            />
          </div>

          <!-- BASIC INFO -->
          <div class="row g-2 small mb-3">
            <div class="col-md-4"><label>Vessel</label><input v-model="form.vesselName" class="form-control form-control-sm"/></div>
            <div class="col-md-4"><label>PIC</label><input v-model="form.engagedBy" class="form-control form-control-sm"/></div>
            <div class="col-md-4"><label>Driver</label><input v-model="form.driverName" class="form-control form-control-sm"/></div>

            <div class="col-md-3"><label>Date</label><input v-model="form.date" type="date" class="form-control form-control-sm"/></div>
            <div class="col-md-3">
              <label>Start Time</label>
              <input
                v-model="form.timeStart"
                type="text"
                placeholder="HH:mm"
                class="form-control form-control-sm"
              />
            </div>

            <div class="col-md-3">
              <label>End Time</label>
              <input
                v-model="form.timeEnd"
                type="text"
                placeholder="HH:mm"
                class="form-control form-control-sm"
              />
            </div>
            <div class="col-md-3"><label>Vehicle No</label><input v-model="form.vehicleNo" class="form-control form-control-sm"/></div>

            <div class="col-md-6"><label>From</label><input v-model="form.from" class="form-control form-control-sm"/></div>
            <div class="col-md-6"><label>To</label><input v-model="form.to" class="form-control form-control-sm"/></div>

            <div class="col-md-6"><label>Crew</label><input v-model="form.paxName" class="form-control form-control-sm"/></div>
            <div class="col-md-6"><label>Rank</label><input v-model="form.rank" class="form-control form-control-sm"/></div>
            <div class="col-md-6"><label>Pax</label><input v-model="form.paxs" type="number" class="form-control form-control-sm"/></div>
            <div class="col-md-6"><label>Flight</label><input v-model="form.flightNo" class="form-control form-control-sm"/></div>
            <!-- SERVICES -->
            <hr class="my-4" />
            <h6 class="fw-bold">Services</h6>

            <div class="row g-2 small">
              <div class="col-md-3 form-check">
                <input type="checkbox" v-model="form.crewTransportation" class="form-check-input">
                <label class="form-check-label">Crew Transportation</label>
                <!-- <input
                    v-if="form.crewTransportation"
                    type="number"
                    class="form-control form-control-sm mt-1"
                    placeholder="Amount"
                    v-model.number="serviceFlags.crewTransportation.amount"
                  /> -->
              </div>

              <div class="col-md-3 form-check">
                <input type="checkbox" v-model="form.delivery" class="form-check-input">
                <label class="form-check-label">Delivery / Collection</label>
                <!-- <input
                    v-if="form.delivery"
                    type="number"
                    class="form-control form-control-sm mt-1"
                    placeholder="Amount"
                    v-model.number="serviceFlags.deliveryCollection.amount"
                  /> -->
              </div>

              <div class="col-md-3 form-check">
                <input type="checkbox" v-model="form.erp" class="form-check-input">
                <label class="form-check-label">ERP</label>
                <!-- <input
                    v-if="form.erp"
                    type="number"
                    class="form-control form-control-sm mt-1"
                    placeholder="Amount"
                    v-model.number="serviceFlags.erp.amount"
                  /> -->
              </div>

              <div class="col-md-3 form-check">
                <input type="checkbox" v-model="form.waitingHrs" class="form-check-input">
                <label class="form-check-label">Waiting Hrs</label>
                <!-- <input
                    v-if="form.waitingHrs"
                    type="number"
                    class="form-control form-control-sm mt-1"
                    placeholder="Amount"
                    v-model.number="serviceFlags.waitingHrs.amount"
                  /> -->
              </div>

              <div class="col-md-3 form-check">
                <input type="checkbox" v-model="form.mealsForCrew" class="form-check-input">
                <label class="form-check-label">Meals</label>
                <!-- <input
                    v-if="form.mealsForCrew"
                    type="number"
                    class="form-control form-control-sm mt-1"
                    placeholder="Amount"
                    v-model.number="serviceFlags.meals.amount"
                  /> -->
              </div>

              <div class="col-md-3 form-check">
                <input type="checkbox" v-model="form.additionalStop" class="form-check-input">
                <label class="form-check-label">Additional Stop</label>
                <!-- <input
                    v-if="form.additionalStop"
                    type="number"
                    class="form-control form-control-sm mt-1"
                    placeholder="Amount"
                    v-model.number="serviceFlags.additionalStop.amount"
                  /> -->
              </div>

              <div class="col-md-3 form-check">
                <input type="checkbox" v-model="form.parkingFees" class="form-check-input">
                <label class="form-check-label">Parking</label>
                <!-- <input
                    v-if="form.parkingFees"
                    type="number"
                    class="form-control form-control-sm mt-1"
                    placeholder="Amount"
                    v-model.number="serviceFlags.parking.amount"
                  /> -->
              </div>

              <div class="col-md-3 form-check">
                <input type="checkbox" v-model="form.oddHrsSurcharge" class="form-check-input">
                <label class="form-check-label">Odd Hrs</label>
                <!-- <input
                    v-if="form.oddHrsSurcharge"
                    type="number"
                    class="form-control form-control-sm mt-1"
                    placeholder="Amount"
                    v-model.number="serviceFlags.oddSurcharge.amount"
                  /> -->
              </div>

              <div class="col-md-3 form-check">
                <input type="checkbox" v-model="form.meetingServices" class="form-check-input">
                <label class="form-check-label">Meeting</label>
                <!-- <input
                    v-if="form.meetingServices"
                    type="number"
                    class="form-control form-control-sm mt-1"
                    placeholder="Amount"
                    v-model.number="serviceFlags.meeting.amount"
                  /> -->
              </div>

              <div class="col-md-3 form-check">
                <input type="checkbox" v-model="form.disposal" class="form-check-input">
                <label class="form-check-label">Disposal</label>
                <!-- <input
                    v-if="form.disposal"
                    type="number"
                    class="form-control form-control-sm mt-1"
                    placeholder="Amount"
                    v-model.number="serviceFlags.disposal.amount"
                  /> -->
              </div>
              <div class="col-md-3 form-check">
                <input type="checkbox" v-model="form.disposal" class="form-check-input">
                <label class="form-check-label">Disposal</label>
                
              </div>
              <div class="col-md-3 form-check">
                <input type="checkbox" v-model="form.arrival" class="form-check-input">
                <label class="form-check-label">Arrival</label>
                
              </div>
              <div class="col-md-3 form-check">
                <input type="checkbox" v-model="form.departure" class="form-check-input">
                <label class="form-check-label">Departure</label>
                
              </div>
            </div>

            <!-- CONDITIONAL INPUTS -->
            <div class="mt-3" v-if="form.waitingHrs">
              <label>Waiting Hrs Info</label>
              <input v-model="form.waitingHrsInfo"
                    class="form-control form-control-sm" />
            </div>

            <div class="mt-3" v-if="form.additionalStop">
              <label>Additional Stop Info</label>
              <input v-model="form.additionalStopInfo" class="form-control form-control-sm" />
            </div>

            <div class="mt-3" v-if="form.disposal">
              <label>Disposal Info</label>
              <input v-model="form.disposalInfo" class="form-control form-control-sm" />
            </div>

            <div class="col-12"><label>Remarks</label>
              <textarea v-model="form.remarks" class="form-control form-control-sm"/>
            </div>
          </div>

          <!-- SIGNATURE -->
          <h6 class="fw-bold mt-3">Signature</h6>
          <canvas
            ref="signaturePad"
            width="600"
            height="160"
            class="border rounded"
            style="touch-action:none"
            @mousedown="startSign"
            @mousemove="drawSign"
            @mouseup="endSign"
            @mouseleave="endSign"
            @touchstart.prevent="startSign"
            @touchmove.prevent="drawSign"
            @touchend.prevent="endSign"
          />
          <button class="btn btn-sm btn-outline-secondary mt-2" @click="clearSign">
            Clear Signature
          </button>

          <div class="text-center mt-4">
            <button class="btn btn-primary px-4" @click="replaceVoucher" :disabled="isUploading">
              <span v-if="!isUploading">Update Voucher</span>
              <span v-else class="spinner-border spinner-border-sm"></span>
            </button>
          </div>

        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@/components/Layout.vue'
import axios from 'axios'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { useToast } from 'vue-toastification'
import router from '@/router'

export default {
  name: 'AdminVoucher',
  components: { Layout },

  data() {
    return {
      voucherId: '',
      voucherBg: require('@/assets/transportVoucher.png'),
      isUploading: false,
      signing: false,
      signCtx: null,
      signatureUrl: '',
      serviceFlags: {
        crewTransportation: { label:'Crew Transportation', amount:0 },
        deliveryCollection: { label:'Delivery / Collection', amount:0 },
        erp: { label:'ERP', amount:0 },
        waitingHrs: { label:'Waiting Hrs', amount:0 },
        meals: { label:'Meals for Crew', amount:0 },
        additionalStop: { label:'Additional Stop', amount:0 },
        parking: { label:'Parking Fee', amount:0 },
        oddSurcharge: { label:'Odd Hrs Surcharge', amount:0 },
        meeting: { label:'Meeting Services', amount:0 },
        disposal: { label:'Disposal', amount:0 }
      },
      form: {
        vesselName: '',
        engagedBy: '',
        driverName: '',
        vehicleNo: '',
        date: '',
        timeStart: '',
        timeEnd: '',
        from: '',
        to: '',
        paxName: '',
        rank:'',
        paxs: 0,
        flightNo: '',
        remarks: '',

        // ===== SERVICE TYPE =====
        crewTransportation: false,
        delivery: false,

        // ===== SERVICES =====
        erp: false,
        mealsForCrew: false,
        parkingFees: false,
        meetingServices: false,
        oddHrsSurcharge: false,
        waitingHrs: false,
        waitingHrsInfo: '',   // 🔥 NEW
        additionalStop: false,
        disposal: false,
        arrival: false,
        departure: false,

        additionalStopInfo: '',
        disposalInfo: ''
      }

    }
  },

  setup() {
    return { toast: useToast() }
  },
  // watch:{
  //     serviceFlags:{
  //       handler(){
  //         this.updateServiceRemarks()
  //       },
  //       deep:true
  //     },
  //     form:{
  //       handler(){
  //         this.updateServiceRemarks()
  //       },
  //       deep:true
  //     }
  //   } ,

  async mounted() {
    this.voucherId = this.$route.params.voucherId

    const auth = getAuth()
    await this.checkPageAccess(["admin"])

    onAuthStateChanged(auth, async user => {
      if (!user) {
        this.toast.error("Please login again")
        return router.push('/login')
      }
      await this.fetchVoucher()
    })
    // this.$nextTick(() => {
    //   const c = this.$refs.signaturePad
    //   const rect = c.getBoundingClientRect()

    //   c.width = rect.width
    //   c.height = rect.height
    // })

    Object.keys(this.form).forEach(k => {
      this.$watch(`form.${k}`, this.drawVoucher)
    })
  },

  methods: {
    checkPageAccess(allowedRoles = []) {
      const access = this.$store.state.systemAccess || {}

      const hasAccess = allowedRoles.some(role => access[role] === true)

      if (!hasAccess) {
        this.toast.error("Access denied.")

        if (access.admin === true) {
          router.push("/crm")
        } else if (access.client === true) {
          router.push("/JobManagementClient")
        } else if (access.driver === true) {
          router.push("/JobManagementDriver")
        } else {
          router.push("/")
        }
      }
    },
    async getAuthHeader() {
      const user = getAuth().currentUser
      return { Authorization: await user.getIdToken() }
    },

    async fetchVoucher() {
      const headers = await this.getAuthHeader()
      const res = await axios.get(
        `${this.$apiURL}/api/vouchers/${this.voucherId}`,
        { headers }
      )

      if (!res.data.ok) {
        return this.toast.error("Voucher not found")
      }

      const v = res.data.voucherData

      this.form = {
        vesselName: v.vesselName || '',
        engagedBy: v.engagedBy || '',
        driverName: v.driverName || '',
        vehicleNo: v.vehicleNo || '',
        date: v.date || '',
        timeStart: v.timeStart || '',
        timeEnd: v.timeEnd || '',
        from: v.from || '',
        to: v.to || '',
        paxName: v.paxName || '',
        rank: v.rank || '',

        paxs: v.paxs || 0,
        flightNo: v.flightNo || '',
        remarks: v.remarks || '',

        crewTransportation: !!v.crewTransportation,
        delivery: !!v.delivery,
        waitingHrsInfo: v.waitingHrsInfo || '',

        erp: !!v.erp,
        mealsForCrew: !!v.mealsForCrew,
        parkingFees: !!v.parkingFees,
        meetingServices: !!v.meetingServices,
        oddHrsSurcharge: !!v.oddHrsSurcharge,
        waitingHrs: !!v.waitingHrs,
        additionalStop: !!v.additionalStop,
        disposal: !!v.disposal,
        arrival: !!v.arrival,
        departure: !!v.departure,

        additionalStopInfo: v.additionalStopInfo || '',
        disposalInfo: v.disposalInfo || ''
      }

      this.signatureUrl = res.data.signatureUrl || ''
      if (this.signatureUrl) {
        const img = new Image()
        img.crossOrigin = "anonymous"
        img.src = this.signatureUrl

        img.onload = () => {
          const c = this.$refs.signaturePad
          const ctx = c.getContext('2d')
          ctx.clearRect(0, 0, c.width, c.height)
          ctx.drawImage(img, 0, 0, c.width, c.height)
          // 🔥 ONLY DRAW AFTER signature loaded
          this.drawVoucher()
        }
      } else {
        // if no signature just draw normally
        this.drawVoucher()
      }// redraw main canvas after signature loaded

    },
    updateServiceRemarks(){

      const lines = []

      const map = {
        crewTransportation: 'crewTransportation',
        delivery: 'deliveryCollection',
        erp: 'erp',
        waitingHrs: 'waitingHrs',
        mealsForCrew: 'meals',
        additionalStop: 'additionalStop',
        parkingFees: 'parking',
        oddHrsSurcharge: 'oddSurcharge',
        meetingServices: 'meeting',
        disposal: 'disposal'
      }

      Object.keys(map).forEach(formKey => {

        const flagKey = map[formKey]

        if (this.form[formKey]) {

          const svc = this.serviceFlags[flagKey]
          const amount = svc?.amount

          if (amount && amount > 0) {
            lines.push(`${svc.label} SGD$${amount}`)
          }

        }

      })

      this.form.remarks = lines.join(' ')

    },


    drawVoucher() {
      const canvas = this.$refs.voucherCanvas
      const ctx = canvas.getContext('2d')
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.src = this.voucherBg

      img.onload = () => {
        canvas.width = img.width
        canvas.height = img.height
        ctx.drawImage(img, 0, 0)

        ctx.fillStyle = '#000'
        ctx.font = '26px Arial'

        // ctx.font = '35px Arial' 
        ctx.fillStyle = 'red' 
        ctx.fillText(this.voucherId, 1570, 75) 
        ctx.fillStyle = 'black' 
        ctx.fillText(this.form.paxs, 650, 300) 
        ctx.fillText(this.form.vesselName, 430, 450) 
        ctx.fillText(this.form.date, 1450, 140) 
        ctx.fillText(this.form.flightNo, 1640, 240) 
        ctx.fillText(this.form.rank, 1300, 380) 
        ctx.fillText(this.form.paxName, 430, 380) 
        ctx.fillText(this.form.from, 430, 520) 
        ctx.fillText(this.form.to, 1300, 520) 
        ctx.fillText(this.form.vehicleNo, 400, 1020) 
        ctx.fillText(this.form.engagedBy, 1300, 450) 
        ctx.fillText(this.form.driverName, 720, 1020) 
        // ctx.fillText(this.form.time, 560, 230) 
        // ctx.fillText(this.form.crew, 270, 350) 
        // ctx.fillText(this.form.remarks, 400, 1120)
        ctx.font = '20px Arial'

        const remarks = this.form.remarks || ""
        const maxWidth = ctx.measureText("WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW").width
        const lineHeight = 83

        let y = 1120
        let line = ""
        let lineCount = 0

        for (let i = 0; i < remarks.length; i++) {

          // if already on line 3 → no more wrapping
          if (lineCount === 2) {
            line += remarks.slice(i)
            break
          }

          const testLine = line + remarks[i]
          const width = ctx.measureText(testLine).width

          if (width > maxWidth && line !== "") {

            ctx.fillText(line, 360, y)

            line = remarks[i]
            y += lineHeight
            lineCount++

          } else {
            line = testLine
          }

        }

        ctx.fillText(line, 360, y)
        ctx.font = '26px Arial'
        ctx.fillText(this.form.timeStart, 430, 590)
        ctx.fillText(this.form.timeEnd, 1300, 590)
        // Services ✔
        // ===== Services (hard-coded positions) =====
        // ctx.font = '26px Arial'
        ctx.fillStyle = '#000'
        ctx.font = '45px Arial'

        if (this.form.departure) {

          const x = 1460
          const y = 240
          const radius = 35
          ctx.lineWidth = 6   // thicker border

          ctx.beginPath()
          ctx.arc(x, y, radius, 0, Math.PI * 2)
          ctx.stroke()

        }
        if (this.form.arrival) {

          const x = 1390
          const y = 240
          const radius = 35
          ctx.lineWidth = 6   // thicker border
          ctx.beginPath()
          ctx.arc(x, y, radius, 0, Math.PI * 2)
          ctx.stroke()
          
        }

        // Crew Transportation
        if (this.form.crewTransportation) {
          ctx.fillText('✔', 385, 300)
        }

        // Delivery / Collection
        if (this.form.delivery) {
          ctx.fillText('✔', 900, 300)
        }
        // ERP
        if (this.form.erp) {
          ctx.fillText('✔', 210, 765)
        }

        // Waiting Hours
        if (this.form.waitingHrs) {
          ctx.fillText('✔', 470, 760)
          if (this.form.waitingHrsInfo) {
             ctx.font = '26px Arial'
             const text = this.form.waitingHrsInfo

            if (text.length <= 15) {
              ctx.fillText(text, 675, 760)
            } else {
              const line1 = text.slice(0, 15)
              const line2 = text.slice(15)

              ctx.fillText(line1, 675, 760)
              ctx.fillText(line2, 675, 785) // move down a bit
            }
          ctx.font = '45px Arial'

          }
        }

        // Meals for Crew
        if (this.form.mealsForCrew) {
          ctx.fillText('✔', 875, 760)
        }

        // Additional Stop
        if (this.form.additionalStop) {
          ctx.fillText('✔', 1165, 760)
          if (this.form.additionalStopInfo) {
            ctx.font = '26px Arial'
            ctx.fillText(this.form.additionalStopInfo, 1400, 755)
            ctx.font = '45px Arial'

          }
        }

        // Parking Fee
        if (this.form.parkingFees) {
          ctx.fillText('✔', 210, 870)
        }

        // Odd Hours Surcharge
        if (this.form.oddHrsSurcharge) {
          ctx.fillText('✔', 470, 870)
        }

        // Meeting Services
        if (this.form.meetingServices) {
          ctx.fillText('✔', 875, 870)
        }

        // Disposal
        if (this.form.disposal) {
          ctx.fillText('✔', 1165, 870)
          if (this.form.disposalInfo) {
            ctx.font = '26px Arial'
            ctx.fillText(this.form.disposalInfo, 1365, 855)

          }
        }
        ctx.font = '26px Arial'

        // if (this.form.additionalStopInfo)
        //   ctx.fillText(this.form.additionalStopInfo, 180, 720)

        // if (this.form.disposalInfo)
        //   ctx.fillText(this.form.disposalInfo, 180,720)

        // Signature
        const sig = this.$refs.signaturePad
        ctx.drawImage(sig, 1300, 1000, 250, 250)

      }
    },

    async replaceVoucher() {
      this.isUploading = true
      try {
        const headers = await this.getAuthHeader()
        const formData = new FormData()

        formData.append("data", JSON.stringify(this.form))

        const voucherBlob = await new Promise(resolve =>
          this.$refs.voucherCanvas.toBlob(resolve, "image/png")
        )
        if (voucherBlob) {
          formData.append("file", voucherBlob, `TransportVoucher_${this.voucherId}.png`)
        }

        const sigBlob = await new Promise(resolve =>
          this.$refs.signaturePad.toBlob(resolve, "image/png")
        )
        if (sigBlob) {
          formData.append("signature", sigBlob, `Signature_${this.voucherId}.png`)
        }

        const res = await axios.put(
          `${this.$apiURL}/api/vouchers/${this.voucherId}`,
          formData,
          { headers }
        )

        if (res.data.ok) {
          this.toast.success("Voucher updated successfully")
          setTimeout(() => router.push("/JobManagement"), 600)
        } else {
          this.toast.error(res.data.error || "Update failed")
        }

      } catch (err) {
        console.error(err)
        this.toast.error("Error updating voucher")
      } finally {
        this.isUploading = false
      }
    },
    startSign(e) {
      const c = this.$refs.signaturePad
      const ctx = c.getContext('2d')

      this.signCtx = ctx
      this.signCtx.strokeStyle = '#000'
      this.signCtx.lineWidth = 2

      const rect = c.getBoundingClientRect()
      const p = e.touches ? e.touches[0] : e

      const x = p.clientX - rect.left
      const y = p.clientY - rect.top

      this.signing = true
      this.signCtx.beginPath()
      this.signCtx.moveTo(x, y)
    },

    drawSign(e) {
      if (!this.signing) return

      const c = this.$refs.signaturePad
      const rect = c.getBoundingClientRect()
      const p = e.touches ? e.touches[0] : e

      const x = p.clientX - rect.left
      const y = p.clientY - rect.top

      this.signCtx.lineTo(x, y)
      this.signCtx.stroke()
    },

    endSign() {
      this.signing = false
      this.drawVoucher()
    },

  }
}
</script>
